import React from 'react';

const EcmaScript = () => (
  <section id="ecmascript">
    <h1>EcmaScript</h1>
    {/* <h3><em>By Ecma International</em></h3> */}
    <p>
      {/* Créé en 1996<br /> */}
      Standardisation du <strong>JavaScript</strong><br />
      {/* On parle de la norme <strong>ECMA-262</strong> */}
    </p>

    <h3>L'age sombre</h3>
    <p>1997 (ES1) ⇨ 2009 (ES5)</p>
    <h3>JS moderne</h3>
    <ul>
      <li>(ES)2015 : ES6 <small>(Babel)</small></li>
      <li>(ES)2016 : ES7 <small>(Array...)</small></li>
      <li>(ES)2017 : ES8 <small>(Async / Await)</small></li>
      <li>(ES)2018 : ES9 <small>(Rest / Spread)</small></li>
      <li>(ES)2019 : ES10... <small>(ESNext)</small></li>
    </ul>
  </section>
);

export default EcmaScript;
